<template>
  <h1>{{ title }}</h1>
</template>
<script>
export default {
  setup: () => ({
    title: 'Componente Vue cargado.',
  }),
}
</script>
